module.exports = fox._r("images/valentines18/gift-46.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/valentines18/gift-46.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/valentines18/gift-46.png
// module id = 270
// module chunks = 4